module.exports = __webpack_public_path__ + "static/media/loading.8c636777.gif";